import { type CartControllerAddResponse } from '@redteclab/api/clients/bully'

import { apmCaptureError } from '../../apm'
import { CustomError } from '../../base-errors'
import { useSearchParamDependentOpenableControls } from '../../generic-hooks'
import { userApiSwrRefetchMiniCart } from '../../user-data'
import {
  type CartIntermediateMultipleProductsAddToCartProps,
  useCartIntermediateApiSwrMultipleProductsAddToCartMutation,
} from '../api/swr/useCartIntermediateApiSwrMultipleProductsAddToCartMutation'

export const useMultipleProductsAddToCart = ({
  currentPrescriptionType,
  offerId,
  quantity,
  recommendedProductId,
}: CartIntermediateMultipleProductsAddToCartProps): {
  addToCartReponseData: CartControllerAddResponse[] | null | undefined
  handleAddToCart: () => Promise<void>
  isAddProductToCartSuccessful: boolean
  isMutating: boolean
} => {
  const { handleOpen: openCartIntemediateSlider } =
    useSearchParamDependentOpenableControls({
      paramName: 'cartIntermediateDrawerBuyTogetherWith',
    })

  const productAddToCartMutation =
    useCartIntermediateApiSwrMultipleProductsAddToCartMutation({
      currentPrescriptionType,
      offerId,
      quantity,
      recommendedProductId,
    })

  const handleAddToCart = async (): Promise<void> => {
    try {
      await productAddToCartMutation.trigger()
      await userApiSwrRefetchMiniCart()
    } catch (error) {
      apmCaptureError(
        new CustomError(
          {
            message: 'failed to add product to the cart',
            name: 'CART_INTERMEDIATE_ADD_TO_CART_BUY_TOGETHER_FAIL',
          },
          {
            cause: error,
          },
        ),
      )
    } finally {
      openCartIntemediateSlider()
    }
  }

  return {
    addToCartReponseData: productAddToCartMutation.data,
    handleAddToCart,
    isAddProductToCartSuccessful: Boolean(
      productAddToCartMutation.data && !productAddToCartMutation.error,
    ),
    isMutating: productAddToCartMutation.isMutating,
  }
}
